<template>
  <div class="row">
    <div class="col-12 my-2">
      <div class="card-header-actions">
        <div class="col-lg-8 col-md-8 col-12 card-header-filter-box">
          <div class="row align-items-end">
            <div class="col-12 col-sm-4 card-header-select-box pr-sm-2">
              <div class="form-group">
                <label>{{ $t("realEstate.field.province") }}:</label>
                <v-select
                    label="name"
                    v-model="province"
                    :filterable="false"
                    :options="provinces"
                    @search="onProvinceSearch"
                    @search:focus="onProvinceFocus"
                >
                  <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                </v-select>
              </div>
            </div>
            <div class="col-12 col-sm-4 card-header-select-box px-sm-2">
              <div class="form-group">
                <label>{{ $t("realEstate.field.region") }}:</label>
                <v-select
                    label="name"
                    v-model="region"
                    :filterable="false"
                    :options="regions"
                    @search="onRegionSearch"
                    @search:focus="onRegionFocus"
                >
                  <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                </v-select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
          <button class="all-btn add-btn m-0" v-if="hasFormulaPermission" @click="onShowFormulaEditModal">
            {{ $t("action.add") }}
          </button>
          <button class="all-btn m-0 ml-3" @click="onSearch">
            <i class="fa fa-search"></i>
            <span>{{ $t('main.search') }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="table-wrapper">
        <table class="customers">
          <thead>
            <tr>
              <th rowspan="2">#</th>
              <th rowspan="2">Вилоят</th>
              <th rowspan="2">Туман</th>
              <th rowspan="2">{{ $t("realEstate.field.createdDate") }}</th>
              <th rowspan="2">{{ $t("realEstate.field.createdBy") }}</th>
              <th :colspan="reference.fields.length">{{reference.name}}</th>
            </tr>
            <tr>
              <th v-for="field in reference.fields" :key="field.id">{{field.name}}</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="!loading && results && results.data">
              <template v-for="formula in results.data">
                <tr :key="`row-item-province-${formula.id}`">
                  <td :rowspan="formula.items.length + 1">
                    {{ formula.id }}
                  </td>
                  <td :rowspan="formula.items.length + 1">
                    {{formula.province.name}}
                  </td>
                </tr>
                <tr v-for="(item, itemIndex) in formula.items" :key="`row-item-province-${formula.id}-row-item-regions-${itemIndex}`">
                  <td :key="`item-region-${itemIndex}`" v-if="item.region && item.region.name">
                    {{item.region.name}}
                  </td>
                  <td :key="`item-created-date-${itemIndex}`">
                    {{new Date(item.createdDate) | dateFormat('DD/MM/YYYY HH:mm')}}
                  </td>
                  <td :key="`item-created-by-${itemIndex}`">
                    {{item.createdBy.name}}
                  </td>
                  <template v-for="(referenceItem, referenceItemKeyIndex) in reference.fields">
                    <td class="text-right" :key="`item-reference-${referenceItem.code}-${referenceItemKeyIndex}`" v-if="item.data.hasOwnProperty(referenceItem.code)">{{item.data[referenceItem.code].value}}</td>
                  </template>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
      <div class="text-center">
        <div class="loader mt-5 mb-5" v-if="loading"></div>
        <span class="no-data mt-5 mb-5"
              v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty") }}</span>
      </div>
      <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
        <div class="col-12 pt-3 pb-3">
          <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size"
                        @change="onPageChange">
          </b-pagination>
        </div>
      </div>
    </div>
    <FormulaEditModal :reference="reference"></FormulaEditModal>
  </div>
</template>
<script>
import initFilterModel from '@/shared/filter';
import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
import FormulaEditModal from "@/views/config/real-estate/FormulaEditModal.vue";

export default {
  name: "FormulaList",
  components: {
    FormulaEditModal,
    'b-pagination': bPagination
  },
  props: {
    type: String,
    name: String
  },
  data() {
    return {
      loading: false,
      filter: initFilterModel(),
      filterProvince: initFilterModel(),
      filterRegion: initFilterModel(),
      results: null,
      province: null,
      region: null,
      microRegion: null,
      provinces: [],
      regions: [],
      reference: {
        code: this.$props.type,
        name: this.$props.name,
        fields: []
      }
    }
  },
  computed: {
    hasFormulaPermission() {
      return (this.$props.type === 'HousingType' && this.hasPermission('SETTINGS_BUILDING_FORMULA_HOUSING_TYPE_ADD')) ||
          (this.$props.type === 'SeparateBuilding' && this.hasPermission('SETTINGS_BUILDING_FORMULA_SEPARATE_BUILDING_ADD')) ||
          (this.$props.type === 'BasementBuildingType' && this.hasPermission('SETTINGS_BUILDING_FORMULA_BASEMENT_TYPE_ADD')) ||
          (this.$props.type === 'BuildingPeriod' && this.hasPermission('SETTINGS_BUILDING_FORMULA_PERIOD_ADD')) ||
          (this.$props.type === 'BuildingStoreys' && this.hasPermission('SETTINGS_BUILDING_FORMULA_STOREYS_ADD')) ||
          (this.$props.type === 'elevator' && this.hasPermission('SETTINGS_BUILDING_FORMULA_ELEVATOR_ADD')) ||
          (this.$props.type === 'BuildingPeriodOfLand' && this.hasPermission('SETTINGS_BUILDING_FORMULA_PERIOD_ADD')) ||
          (this.$props.type === 'BuildingCityCenter' && this.hasPermission('SETTINGS_BUILDING_FORMULA_CITY_CENTER_ADD')) ||
          (this.$props.type === 'SpecialComforts' && this.hasPermission('SETTINGS_BUILDING_FORMULA_SPECIAL_COMFORT_ADD')) ||
          (this.$props.type === 'RegionCorrectionCoefficient' && this.hasPermission('SETTINGS_BUILDING_FORMULA_REGION_COEFFICIENT_ADD'))
    }
  },
  methods: {
    initList() {
      this.loading = true;
      const vm = this;

      this.filter.code = this.$props.type
      this.filter.page.size = 2
      this.$http.post('/cadastre-building-field-reference-formula/list', this.filter)
          .then(res => {
            this.results = res.data;
            vm.loading = false;
          }, err => {
            console.log(err);
            vm.loading = false;
          });
    },
    initData() {
      this.$http.get('/cadastre/building/field/reference-parent-code/' + this.type)
          .then(res => {
            this.reference.fields= res.data
          }, err => {
            console.log(err);
          });
    },
    onShowFormulaEditModal() {
      this.$eventBus.$emit("showFormulaEditModal", this.reference)
    },
    onPageChange(page) {
      this.filter.page.page = page;
      this.initList();
    },
    onProvinceFocus() {
      this.provinces = [];
      this.filterProvince.search = '';
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onProvinceSearch(searchTxt, loading) {
      loading(true);
      this.provinces = [];
      this.filterProvince.search = searchTxt;
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onRegionSearch(searchTxt, loading) {
      loading(true);
      this.regions = [];
      this.filterRegion.search = searchTxt;
      this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
      this.$http.post('/region/search', this.filterRegion)
          .then(res => {
            this.regions = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onRegionFocus() {
      this.regions = [];
      this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
      this.$http.post('/region/search', this.filterRegion)
          .then(res => {
            this.regions = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onSearch() {
      this.filter.code = this.$props.type
      this.filter.provinceId = this.province ? this.province.id : null;
      this.filter.regionId = this.region ? this.region.id : null;
      this.initList();
    }
  },
  created() {
    this.filterProvince.page.size = 1000;
    this.filterRegion.page.size = 1000;
    this.initList();
    this.initData()
    this.$eventBus.$on('formulaChanged', () => {
      this.initList();
    });
  }
}
</script>

<style scoped>
  .customers th {
    padding: 2px !important;
  }
</style>